angular.module('app').config(priceListsRouting);

function priceListsRouting($routeProvider) {
  $routeProvider
    .when('/price_lists', {
      pageTitle: 'PRICE_LISTS',
      template: '<price-lists-page></price-lists-page>',
      breadcrumb: {
        label: 'COMPANY_SETTINGS',
        parent: 'ng/company_settings',
      },
      accessPermission: 'index_pricelist_accountadmin',
      authReq: true,
    })
    .when('/price_lists/new', {
      pageTitle: 'ADD_PRICE_LIST',
      template: '<price-list-page></price-list-page>',
      breadcrumb: {
        label: 'PRICE_LISTS',
        parent: 'price_lists',
        ajs: true,
      },
      accessPermission: 'create_pricelist_accountadmin',
      authReq: true,
    })
    .when('/price_lists/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'EDIT_PRICE_LIST',
      template: '<price-list-page></price-list-page>',
      breadcrumb: {
        label: 'PRICE_LISTS',
        parent: 'price_lists',
        ajs: true,
      },
      accessPermission: 'show_pricelist_accountadmin',
      authReq: true,
    });
}

priceListsRouting.$inject = ['$routeProvider'];
